webpackJsonp([87],{

/***/ "6vNO":
/***/ (function(module, exports, __webpack_require__) {

var SectionLogoVideoSignUp = (function () {
    SectionLogoVideoSignUp.$inject = ["$stateParams"];
    function SectionLogoVideoSignUp($stateParams) {
        this.$stateParams = $stateParams;
        this.ltTitle = this.$stateParams.t || this.ltTitle;
        this.description = this.$stateParams.d || this.description;
        this.text = this.$stateParams.d || this.text;
        this.logo = _.isBoolean(this.logo) ? this.logo : true;
    }
    return SectionLogoVideoSignUp;
}());
angular.module('animatronApp.sectionLogoVideoSignUp', []).component('sectionLogoVideoSignUp', {
    bindings: {
        brandLogo: '<',
        logo: '<',
        ltTitle: '<',
        description: '<',
        text: '<',
        background: '<',
        sbTitle: '<',
        image: '<',
        video: '<'
    },
    controller: SectionLogoVideoSignUp,
    templateUrl: __webpack_require__("bxKh")
});


/***/ }),

/***/ "bxKh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-logo-video-sign-up_29f2fcc4dbef7bde60d0e966d243c8da.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/87-257c10c0995a4d25fa59.min.js